import { render, staticRenderFns } from "./GvntInfo.vue?vue&type=template&id=37c22e46&"
import script from "./GvntInfo.vue?vue&type=script&lang=js&"
export * from "./GvntInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports